import { Box, Button, Text } from '@cmpsr/components';
import { VARS } from '../../common/constants';

interface StickyPurchaseButtonProps {
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick: () => void;
  isTrial?: boolean;
}

export function StickyPurchaseButton({ isDisabled, isLoading, onClick, isTrial }: StickyPurchaseButtonProps) {
  const handleClick = () => {
    // Call onClick which will handle validation and scrolling if needed
    onClick();
  };

  const buttonText = isTrial ? 'Start Your 7 Day Free Trial' : VARS.cta.message;

  return (
    <Box
      position="fixed"
      bottom="0"
      width={{ base: '285px', lg: '600px' }}
      background="gradient.light"
      zIndex="5"
      marginBottom="spacer-4"
      left="50%"
      transform="translateX(-50%)"
    >
      <Button
        display="flex"
        paddingX={{ base: 'spacer-5', lg: 'spacer-5' }}
        paddingY="spacer-5"
        justifyContent="center"
        alignItems="center"
        gap="spacer-2.5"
        flex="1 0 0"
        borderRadius="100px"
        background="#7CF1C7"
        alignSelf="stretch"
        width="100%"
        isDisabled={isDisabled}
        isLoading={isLoading}
        onClick={handleClick}
      >
        <Text
          color="#183344"
          fontSize={{ base: '14px', lg: '14px' }}
          fontStyle="normal"
          fontWeight={500}
          lineHeight="140%"
        >
          {buttonText}
        </Text>
      </Button>
    </Box>
  );
}

export default StickyPurchaseButton;
